import { render, staticRenderFns } from "./NavigationBlock.vue?vue&type=template&id=6f61cefb&"
import script from "./NavigationBlock.vue?vue&type=script&lang=js&"
export * from "./NavigationBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports